module.exports = __webpack_public_path__ + "img/about-thumb-5.d12fa7dc.png";